
export const pi = Math.PI
export const tau = 2 * Math.PI
export const e = Math.E
export const phi = 1.6180339887498948 // eslint-disable-line no-loss-of-precision
